<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 100 100" fill="#d9dddf" stroke="#d9dddf">
  <path d="M 50,10 95,57.5 5,57.5 z"/>
</svg>
